/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateDashboardRequest } from '../../models/create-dashboard-request';
import { DashboardDto } from '../../models/dashboard-dto';

export interface DashboardsPost$Json$Params {
      body?: CreateDashboardRequest
}

export function dashboardsPost$Json(http: HttpClient, rootUrl: string, params?: DashboardsPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<DashboardDto>> {
  const rb = new RequestBuilder(rootUrl, dashboardsPost$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DashboardDto>;
    })
  );
}

dashboardsPost$Json.PATH = '/dashboards';
